import { Stack, Typography } from "@mui/material";
import { formatShortWeekdayDate } from "@shared";

import { useLanguageContext } from "@/common/contexts/language-context/LanguageContext";
import { locales } from "@/common/contexts/localization-date-context/LocalizationDateContextProvider.utils";
import { formatExchangeAppointmentTime } from "@/pages/exchange/Exchange.utils";
import { useTranslation } from "@/translations";

interface Props {
  startTimeUtc: Date;
  isAllDay: boolean;
}

/** Weekday and date of a swapped appointment, with its start time — or "all day" (Ganztägig) — underneath. */
export function ExchangeHistoryAppointmentCell({ startTimeUtc, isAllDay }: Props) {
  const { t } = useTranslation();
  const { language } = useLanguageContext();
  const locale = locales[language];

  return (
    <Stack justifyContent="center" sx={{ height: "100%" }}>
      <Typography variant="body2" fontWeight={600}>
        {formatShortWeekdayDate(startTimeUtc, locale)}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        {formatExchangeAppointmentTime(startTimeUtc, isAllDay, locale, t)}
      </Typography>
    </Stack>
  );
}
